<!-- Client marquee -->
<div class="container">
    <div class="client-row">
        <div class="row align-items-center flex-wrap text-center">
            <h2 class="font-700 w-100" style="font-size: 2.5rem;">Trusted by <span class="highlight-purple">400+</span> Setups</h2>
        </div>
    </div>
</div>

<div class="clients-list">    
    <section>
        <div class="marquee marquee--hover-pause enable-animation">
          <div class="marquee__content">
            <span *ngFor="let item of client_logos; let i = index" class=" align-content-center justify-content-center">
                <img [src]="item.url" [alt]="item.alt" class="img-opacity">
              </span>
          </div>
      
          <div aria-hidden="true" class="marquee__content">
            <span *ngFor="let item of client_logos; let i = index" class=" align-content-center justify-content-center">
                <img [src]="item.url" [alt]="item.alt" [loading]="'lazy'" class="img-opacity">
            </span>
          </div>
        </div>
      </section>
</div>
